import { Card } from "@app/ui";
import { InboxPanel } from "../features/inbox/index.js";
import { useI18n } from "../lib/useI18n.js";

export function InboxRoute() {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4">
      <h1 className="text-2xl font-semibold">{t("common.inbox")}</h1>
      <p className="text-sm text-muted-foreground">
        {t("inbox.description")}
      </p>
      <Card className="p-3">
        <InboxPanel />
      </Card>
    </div>
  );
}
